import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@devhop/ui";
import SignInForm from "../ui/SignInForm";

export function LoginPage() {
  return (
    <div className="bg-background px-6 py-10">
      <div className="mx-auto flex w-full max-w-md flex-col justify-center gap-6">
        <div className="px-1">
          <p className="font-(--font-heading) text-sm tracking-wide">
            Slurp Coffee Co.
          </p>
          <p className="mt-1 text-muted-foreground text-sm">
            ຍິນດີຕ້ອນຮັບ — ເຂົ້າລະບົບເພື່ອເລີ່ມໃຊ້ POS
          </p>
        </div>

        <Card className="w-full gap-4 border border-foreground/15 bg-card shadow-sm">
          <CardHeader className="gap-3">
            <div className="relative">
              <div className="pointer-events-none select-none opacity-80">
                <svg
                  viewBox="0 0 520 56"
                  width="100%"
                  height="40"
                  aria-hidden="true"
                >
                  <path
                    d="M16 36c40-18 64 12 108-4s60-24 110-8 72 22 132 4 78-12 138-2"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.75"
                  />
                  <path
                    d="M28 46c24-10 42 6 76-2s38-14 78-6 52 16 92 2 58-10 102-2 62 10 108 0"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.35"
                  />
                </svg>
              </div>
            </div>

            <div className="space-y-1">
              <CardTitle className="font-(--font-heading) text-2xl tracking-tight">
                ເຂົ້າລະບົບ
              </CardTitle>
              <CardDescription className="text-base leading-relaxed">
                ໃສ່ອີເມວ ແລະ ລະຫັດຜ່ານຂ້າງລຸ່ມນີ້ ເພື່ອເຂົ້າໃຊ້ບັນຊີຂອງທ່ານ
              </CardDescription>
            </div>
          </CardHeader>

          <CardContent className="pt-0">
            <SignInForm />
            <p className="mt-4 text-muted-foreground text-xs">
              ມີບັນຫາເຂົ້າລະບົບ? ລອງກວດອີເມວ/ລະຫັດຜ່ານອີກຄັ້ງ ຫຼື ຕິດຕໍ່ຜູ້ຈັດການ.
            </p>
          </CardContent>
        </Card>

        <p className="px-1 text-muted-foreground text-xs">
          ກະລຸນາໃຊ້ບັນຊີທີ່ຮ້ານສ້າງໄວ້ໃຫ້. (ໂທນຂາວ-ດໍາ ແລະ ລາຍເສັ້ນບາງໆ ເພື່ອຄວາມຮູ້ສຶກແບບຮ້ານກາເຟ)
        </p>
      </div>
    </div>
  );
}
